import React, { useImperativeHandle, useRef, useState } from 'react';
import AdvancedChartFilterClubDialog from "./AdvancedChartFilterClubDialog";
import AdvancedChartFilterTaggedDialog from "./AdvancedChartFilterTaggedDialog";
import AdvancedChartFilterStatisticsDialog from "./AdvancedChartFilterStatisticsDialog";
import useForkRef from "@Util/hook/useForkRef";

const ChartDialogBox = React.forwardRef((props, ref) => {
    const dialogRef = useRef(null);
    const refreshRef = useRef(null);
    const confirmRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState(null);
    const [filterOptions, setFilterOptions] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const doRefresh = () => {
        refreshRef.current && typeof refreshRef.current === 'function' && refreshRef.current();
    };

    const doConfirm = (result) => {
        confirmRef.current && typeof confirmRef.current === 'function' && confirmRef.current(result);
    }

    useImperativeHandle(combinedRef, () => ({
            openAdvancedChartFilterClubDialog: (targetOptions, refreshFn, selectedFilter, confirmFn) => {
                setFilterOptions(targetOptions);
                setSelectedFilter(selectedFilter);
                setOpenDialog('advChartFilterClub');
                refreshRef.current = refreshFn;
                confirmRef.current = confirmFn;
            },
            openAdvancedChartFilterTaggedDialog: (targetOptions, refreshFn, selectedFilter, confirmFn) => {
                setFilterOptions(targetOptions);
                setSelectedFilter(selectedFilter);
                setOpenDialog('advChartFilterTagged');
                refreshRef.current = refreshFn;
                confirmRef.current = confirmFn;
            },
            openAdvancedChartFilterStatisticsDialog: (statisticsGroupOptions, refreshFn, selectedStatisticsFilter, confirm) => {
                setFilterOptions(statisticsGroupOptions);
                setSelectedFilter(selectedStatisticsFilter);
                setOpenDialog('advChartFilterStatistics');
                refreshRef.current = refreshFn;
                confirmRef.current = confirm;
            }
        }),
        // eslint-disable-next-line
        []
    );

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setFilterOptions(null);
        setSelectedFilter(null);
        refreshRef.current = null;
        confirmRef.current = null;
    };

    return (
        <React.Fragment>
            <AdvancedChartFilterClubDialog
                open={openDialog === 'advChartFilterClub'}
                options={filterOptions}
                selected={selectedFilter}
                onClose={handleCloseDialog}
                refresh={doRefresh}
                onConfirm={doConfirm}
            />
            <AdvancedChartFilterTaggedDialog
                open={openDialog === 'advChartFilterTagged'}
                options={filterOptions}
                selected={selectedFilter}
                onClose={handleCloseDialog}
                refresh={doRefresh}
                onConfirm={doConfirm}
            />
            <AdvancedChartFilterStatisticsDialog
                open={openDialog === 'advChartFilterStatistics'}
                options={filterOptions}
                selected={selectedFilter}
                onClose={handleCloseDialog}
                refresh={doRefresh}
                onConfirm={doConfirm}
            />
        </React.Fragment>
    )
});

export default ChartDialogBox;